import React from 'react';
import { useParams } from 'react-router-dom';
import InvoiceList from './InvoiceList';

const InvoiceListWrapper: React.FC = () => {
  const { organisationId } = useParams<{ organisationId: string }>();

  if (!organisationId) {
    return <div>Organisation ID is required</div>;
  }

  return <InvoiceList organisationId={organisationId} />;
};

export default InvoiceListWrapper;
